<template>
  <el-dialog :append-to-body="true" title="刷卡" :visible.sync="dialogShow" size='tiny' :close-on-click-modal='false' :close-on-press-escape='false' :show-close="showClose" width="35%">
    <div v-loading.body='loading' element-loading-text="拼命加载中" class='pay-block'>
      <el-card class='swipe-img' style='width: 210px ;height: 224px; text-align: left'>
      </el-card>
      <input type='text' ref="number" id='number' style="opacity: 0;" v-model='number' @focus='focus' @blur='blur' @change='change'/>
      <div v-if='!search' v-for='(rentDetail, index) in rentDetails' :key='rentDetail.detailId'>
        <div class='rent-detail'  v-if='rentDetail.materialNum' >{{index + 1}}.  {{rentDetail.materialNum}} <el-button size='mini'  type='warning' @click='clickSwipe(rentDetail.materialNum)' :disabled='transferMaterialNum === rentDetail.materialNum' >换卡</el-button></div>
        <div class='rent-detail'  v-else-if='rentDetail.detailStatus != 2' :key='rentDetail.detailId'>{{index + 1}}. 待写卡</div>
      </div>
      <div>
        <el-button class='pay-button' type="primary" style='position: bottom' @click="clickSwipe(false)" :disabled='isFocus' >{{buttonText}}</el-button>
        <el-button v-if="showCancleButton" class='pay-button' style='position: bottom' @click="onCancel" >取消</el-button>
        <el-button v-if="showConfirmButton" class='pay-button' type="primary" style='position: bottom' @click="onConfirm" >确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import _ from 'lodash'
import api from '../../utils/api'

export default {
  name: 'swipe-card',
  data () {
    return {
      loading: false,
      dialogShow: this.show,
      isFocus: false,
      buttonText: '点击刷卡',
      equipmentRelationships: {},
      rentDetails: [],
      number: '',
      lastInputTime: '',
      count: 999,
      transferMaterialNum: '',
      CardNum: true
    }
  },
  props: {
    code: '',
    show: false,
    orderId: '',
    search: {
      default: false
    },
    defaultFocus: {
      default: false
    },
    isCardNum: {
      // 是否返回卡号
      type: Boolean,
      default: true
    },
    showClose: {
      // 是否显示关闭按钮
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: false
    },
    exceptionHandler: {
      type: Boolean,
      default: false
    },
    showSuccessMessage: {
      type: Boolean,
      default: true
    },
    showCancleButton: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (v, ov) {
      this.dialogShow = v
    },
    dialogShow (v, ov) {
      if (!v) {
        this.$emit('on-block-close', v)
      }
    },
    defaultFocus (v, ov) {
      if (v) {
        this.isFocus = v
      }
    },
    isCardNum (v) {
      this.cardNum = v
    },
    number (v, ov) {
      let time = new Date().getTime()
      if (
        (this.lastInputTime === '' || time - this.lastInputTime < 100) &&
        v.length - ov.length > 0
      ) {
        this.lastInputTime = time
      } else {
        this.number = ''
        this.lastInputTime = ''
      }
      let that = this
      setTimeout(() => {
        if (v === that.number) {
          this.lastInputTime = ''
          if (that.number.length !== 10) {
            this.number = ''
          }
        }
      }, 1000)
    },
    orderId (v) {
      if (v !== '') {
        this.getRentInfo()
      }
    }
  },
  methods: {
    change (e) {
      if (this.number.length === 10) {
        if (this.search) {
          let number = this.number
          this.number = ''
          return this.$emit('on-swipe', number)
        }
        if (this.transferMaterialNum && this.transferMaterialNum !== '') {
          let param = {
            materialNum: this.transferMaterialNum,
            cardNumber: this.number
          }
          this.loading = true
          api.transferCard(param).then(res => {
            this.number = ''
            this.loading = false
            let { code, msg, data } = res
            if (code === 0) {
              this.$message({
                message: msg,
                type: 'success'
              })
              _.each(this.rentDetails, e => {
                if (e.detailId === data.detailId) {
                  e.materialNum = data.materialNum
                }
              })
            } else {
              this.$message({
                message: msg,
                type: 'error'
              })
            }
          })
          return
        }
        // let that = this
        let param = { code: this.code, cardNumber: this.number }
        this.loading = true
        api.outCard(param).then(res => {
          this.number = ''
          this.loading = false
          let { code, msg, data } = res
          if (code === 0) {
            if (this.showSuccessMessage) {
              this.$message({
                message: '写卡成功',
                type: 'success'
              })
            }
            _.each(this.rentDetails, e => {
              console.log(e, data)
              if (e.detailId === data.detailId) {
                e.materialNum = data.materialNum
              }
            })
            this.count = this.count - 1
            if (this.count <= 0) {
              this.$emit('on-swipe-success')
            }
          } else {
            this.$message({
              message: msg,
              type: 'error'
            })
          }
        })
        this.number = ''
      } else {
        this.number = ''
        this.lastInputTime = ''
      }
    },
    focus () {
      this.isFocus = true
      this.buttonText = '请刷卡'
    },
    blur () {
      this.isFocus = false
      this.buttonText = '点击刷卡'
    },
    clickSwipe (materialNum) {
      if (materialNum) {
        this.transferMaterialNum = materialNum
      } else {
        this.transferMaterialNum = ''
      }
      document.getElementById('number').focus()
      this.isFocus = true
      this.buttonText = '请刷卡'
      this.number = ''
      this.lastInputTime = ''
    },
    getRentInfo () {
      let param = { orderId: this.orderId }
      api.getCardInfo(param).then(res => {
        let { code, msg, data } = res
        if (code === 0) {
          this.equipmentRelationships = data.equipmentRelationships
          this.rentDetails = data.rentDetails
          let count = 0
          _.each(data.rentDetails, e => {
            if (e.detailStatus === 0 || e.detailStatus === '0') {
              count++
            }
          })
          this.count = count
        } else {
          this.$message({
            message: msg,
            type: 'error'
          })
          if (!this.exceptionHandler) {
            this.dialogShow = false
          } else {
            this.$emit('exception', res)
          }
        }
      })
    },
    onConfirm () {
      this.$emit('on-block-confirm')
    },
    onCancel () {
      this.$emit('cancel')
    }
  },
  mounted () {
    if (this.defaultFocus) {
      let inter = setInterval(() => {
        if (document.getElementById('number')) {
          let _focus = document.getElementById('number').focus()
          if (_focus && typeof _focus === 'function') {
            this.clickSwipe()
            clearInterval(inter)
          }
        }
      })
    }
    if (!this.search) {
      this.getRentInfo()
    }
  }
}
</script>

<style lang='scss' scoped>
.pay-block {
  text-align: center;
  margin-bottom: -30px;
}
.el-form-item {
  margin-bottom: 0px;
}
.pay-button {
  margin: 10px;
}
.swipe-img {
  background: url("../../assets/images/swipe_bg.png") no-repeat;
  background-size: 100%;
}
.hide-input {
  position: absolute;
  left: 20%;
  z-index: 1;
  opacity: 0;
  cursor: default;
  width: 100px;
}
.el-form-item__label {
  padding-bottom: 0 !important;
}
.rent-detail {
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/swipe-card.vue